export default __webpack_public_path__ + "static/media/The forgotten.cbf438ae.jpg";